<button
  type="button"
  class="artifact-picker__trigger"
  aria-haspopup="listbox"
  [id]="inputId"
  [attr.aria-label]="ariaLabel"
  [attr.aria-expanded]="open"
  [attr.aria-controls]="open ? listboxId : null"
  [disabled]="disabled"
  (click)="toggle()"
  (keydown)="onTriggerKeydown($event)"
>
  <span *ngIf="selectedOption as option; else emptyValue" class="artifact-picker__value">
    <span class="artifact-picker__label">{{ option.label }}</span>
    <span *ngIf="option.meta" class="artifact-picker__meta">{{ option.meta }}</span>
  </span>
  <ng-template #emptyValue>
    <span class="artifact-picker__placeholder">{{ placeholder }}</span>
  </ng-template>
  <span class="artifact-picker__chevron" aria-hidden="true">&#x25BE;</span>
</button>

<div *ngIf="open" class="artifact-picker__panel">
  <input
    #searchInput
    type="search"
    class="artifact-picker__search"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-label]="searchPlaceholder"
    [attr.aria-controls]="listboxId"
    [attr.aria-activedescendant]="filteredOptions.length > 0 ? getOptionId(activeIndex) : null"
    [placeholder]="searchPlaceholder"
    [value]="query"
    (input)="onQueryChanged($event)"
    (keydown)="onSearchKeydown($event)"
  />
  <ul class="artifact-picker__options" role="listbox" [id]="listboxId" [attr.aria-label]="ariaLabel">
    <li
      *ngFor="let option of filteredOptions; let index = index"
      class="artifact-picker__option"
      role="option"
      [id]="getOptionId(index)"
      [class.artifact-picker__option--active]="index === activeIndex"
      [attr.aria-selected]="option.value === value"
      (pointerenter)="activeIndex = index"
      (click)="select(option)"
    >
      <span class="artifact-picker__label">
        <ng-container *ngFor="let segment of highlight(option.label)">
          <mark *ngIf="segment.match">{{ segment.text }}</mark>
          <ng-container *ngIf="!segment.match">{{ segment.text }}</ng-container>
        </ng-container>
      </span>
      <span *ngIf="option.meta" class="artifact-picker__meta">
        <ng-container *ngFor="let segment of highlight(option.meta)">
          <mark *ngIf="segment.match">{{ segment.text }}</mark>
          <ng-container *ngIf="!segment.match">{{ segment.text }}</ng-container>
        </ng-container>
      </span>
      <span *ngIf="option.value === value" class="artifact-picker__check" aria-hidden="true">&#x2713;</span>
    </li>
    <li *ngIf="filteredOptions.length === 0" class="artifact-picker__empty" role="presentation">
      {{ options.length === 0 ? 'Nothing to choose from.' : 'No matches for "' + query.trim() + '"' }}
    </li>
  </ul>
  <div class="artifact-picker__footer">
    <span>{{ filteredOptions.length }} of {{ options.length }}</span>
    <button *ngIf="value !== null" type="button" class="artifact-picker__clear" (click)="clear()">
      Clear selection
    </button>
  </div>
</div>
